export const SUPPORT_PHONE_E164 = '917976757979'
export const SUPPORT_PHONE_DISPLAY = '+91 79767 57979'
export const SUPPORT_PHONE_DISPLAY_PUBLIC = '+91 7976757979'

export const COMPANY_LEGAL_NAME = 'Tejse Online Services Private Limited'
export const OFFICE_ADDRESS_LINES = [
  '4th Floor, 648/A, Om Chambers, Binnamangala, Indiranagar, Bengaluru - 560038'
]
export const OFFICE_ADDRESS_TEXT = OFFICE_ADDRESS_LINES.join(', ')
export const SUPPORT_EMAIL = 'support@scaffoldingapp.com'

const DEFAULT_TRIAL_EXPIRED_WHATSAPP_MESSAGE =
  'Hi, my free trial has ended. I would like help purchasing a subscription plan.'

export function openSupportWhatsApp(
  prefillMessage: string = DEFAULT_TRIAL_EXPIRED_WHATSAPP_MESSAGE
) {
  const text = encodeURIComponent(prefillMessage)
  window.open(
    `https://web.whatsapp.com/send?phone=${SUPPORT_PHONE_E164}&text=${text}`,
    '_blank'
  )
}

export function openSupportPhoneCall() {
  window.open(`tel:+${SUPPORT_PHONE_E164}`, '_self')
}
